<template>
  <div class="tabs-block" id="faq">
    <div class="tabs-block__container">
      <!---->
      <div class="tabs-block__block">
        <input class="radio" id="one" name="group" type="radio" checked />
        <input class="radio" id="two" name="group" type="radio" />
        <input class="radio" id="three" name="group" type="radio" />
        <div class="tabs-block__tabs">
          <label class="tabs-block__tab" id="one-tab" for="one">Details</label>
          <label class="tabs-block__tab" id="two-tab" for="two">Requirements</label>
          <label class="tabs-block__tab" id="three-tab" for="three">Responsibilities</label>
        </div>
        <div class="tabs-block__content">
          <div class="tabs-block__item" id="one-panel">
            <ul>
                <li>Create and edit video content for multi-platform use and distribution for social media channels (Facebook, Youtube, Instagram, Snapchat, IGTV, Facebook Stories and Instagram Stories).</li>
                <li>Design & Create highly engaging industry-related content in both photo, gif & video format</li>
                <li>Publish Posts on various social media channels</li>
                <li>Promote content on social networks and monitor engagement (e.g. comments and shares)</li>
                <li>Research industry-related topics</li>
                <li>Editing audio and sound design on projects</li>
                <li>Engage in opportunities to develop original content and concepts for web and mobile</li>
                <li>Create motion graphics and animations using 2D and 3D applications for marketing and promotional usage.</li>
                <li>
Manage the day-to-day handling of all social media channels such as LinkedIn, Facebook, Twitter, Pinterest, Instagram, Tiktok and YouTube, adapting content to suit different channels</li>
            </ul>
          </div>
          <div class="tabs-block__item" id="two-panel">
            <ul>
                <li>Create and edit video content for multi-platform use and distribution for social media channels (Facebook, Youtube, Instagram, Snapchat, IGTV, Facebook Stories and Instagram Stories).</li>
                <li>222222</li>
                <li>222222</li>
                <li>222222</li>
                <li>222222</li>
                <li>222222</li>
            </ul>
          </div>
          <div class="tabs-block__item" id="three-panel">
            <ul>
                <li>Create and edit video content for multi-platform use and distribution for social media channels (Facebook, Youtube, Instagram, Snapchat, IGTV, Facebook Stories and Instagram Stories).</li>
                <li>333333</li>
                <li>333333</li>
                <li>333333</li>
                <li>333333</li>
                <li>333333</li>
            </ul>
          </div>
        </div>
      </div>
      <!---->
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>

</style>